import React, { useEffect, useRef } from "react";
import { IoMdClose } from "react-icons/io";

interface TechnicalSupportModalProps {
  imageSrc: string;
  onClose: () => void;
}

const TechnicalSupportModal: React.FC<TechnicalSupportModalProps> = ({
  imageSrc,
  onClose,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  // Handle clicks outside of the modal to close it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    // Add event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-50">
      <div
        ref={modalRef}
        className="relative max-w-[95vw] rounded bg-white p-5 md:p-10"
      >
        <button
          onClick={onClose}
          className="absolute end-0 top-0 rounded-md p-2 text-red-600 hover:bg-black/10 md:end-2 md:top-2"
        >
              <IoMdClose size={24} className="text-red-600" />
        </button>
        <img
          src={imageSrc}
          alt="Preview"
          className="max-h-[80vh] max-w-[80vw]"
        />
      </div>
    </div>
  );
};

export default TechnicalSupportModal;
